<template>
  <div class="apr-page">
    <!-- Hero -->
    <div class="hero">
      <div class="hero-txt">
        <div class="hero-eyebrow">PORTAL HR</div>
        <h1 class="hero-title">Aprobări</h1>
        <p class="hero-sub">Tot ce trebuie să acționezi: cereri de aprobat ca superior și confirmări ca înlocuitor.</p>
      </div>
      <div class="co-chip">
        <v-icon size="18" class="mr-1">mdi-clipboard-check-outline</v-icon>
        <span class="co-val">{{ total }}</span>
        <span class="co-lbl">de rezolvat</span>
      </div>
    </div>

    <!-- Tab-uri -->
    <v-tabs v-model="tab" class="apr-tabs" color="#ff5722" density="comfortable">
      <v-tab value="aprob"><v-icon size="18" class="mr-2">mdi-check-decagram-outline</v-icon>De aprobat ({{ concedii.length }})</v-tab>
      <v-tab value="inl"><v-icon size="18" class="mr-2">mdi-account-switch</v-icon>Înlocuiri concedii ({{ inlocuitor.length }})</v-tab>
      <v-tab value="inlt"><v-icon size="18" class="mr-2">mdi-ticket-confirmation-outline</v-icon>Înlocuiri tichete ({{ tichete.length }}) · info</v-tab>
      <v-tab value="decont"><v-icon size="18" class="mr-2">mdi-cash-multiple</v-icon>Deconturi ({{ deconturi.length }})</v-tab>
    </v-tabs>

    <!-- De aprobat (ca superior) -->
    <div v-show="tab === 'aprob'" class="grid-card">
      <div class="grid-head"><v-icon size="18" color="#ff5722" class="mr-2">mdi-check-decagram-outline</v-icon><span>Cereri de aprobat ca superior</span></div>
      <DxDataGrid :data-source="concedii" key-expr="ID" :show-borders="false" :show-column-lines="false" :show-row-lines="true"
        :hover-state-enabled="true" :no-data-text="loading ? 'Se încarcă…' : 'Nu ai cereri de aprobat.'">
        <DxColumn data-field="NumeAngajat" caption="Solicitant" :min-width="180" cell-template="angCell" />
        <DxColumn data-field="TipConcediu" caption="Tip" :width="120" cell-template="tipCell" />
        <DxColumn data-field="PerioadaText" caption="Perioadă" :width="210" cell-template="perCell" :allow-filtering="false" />
        <DxColumn data-field="NumarZile" caption="Zile" :width="70" alignment="center" cell-template="zileCell" />
        <DxColumn data-field="Descriere" caption="Descriere" :min-width="150" />
        <DxColumn caption="" :width="200" :allow-filtering="false" :allow-sorting="false" cell-template="aprobActCell" />
        <template #angCell="{ data }"><div class="ang"><span class="avatar">{{ data.data.Initiale }}</span><span class="ang-nume">{{ data.data.NumeAngajat || 'Angajat' }}</span></div></template>
        <template #tipCell="{ data }"><span class="tip-badge">{{ data.data.TipConcediu || 'CO' }}</span></template>
        <template #perCell="{ data }"><div class="perioada"><v-icon size="15" color="#ff5722" class="mr-1">mdi-calendar-range</v-icon>{{ data.data.PerioadaText }}</div></template>
        <template #zileCell="{ data }"><span class="zile-badge">{{ data.data.NumarZile }}</span></template>
        <template #aprobActCell="{ data }">
          <v-btn size="small" class="btn-ok mr-1" variant="flat" @click="openActiune(data.data, true)"><v-icon size="18">mdi-check</v-icon></v-btn>
          <v-btn size="small" class="btn-no" variant="flat" @click="openActiune(data.data, false)"><v-icon size="18">mdi-close</v-icon></v-btn>
        </template>
        <DxPaging :page-size="12" /><DxSorting mode="single" /><DxFilterRow :visible="true" />
      </DxDataGrid>
    </div>

    <!-- Înlocuiri concedii -->
    <div v-show="tab === 'inl'" class="grid-card">
      <div class="grid-head"><v-icon size="18" color="#ff5722" class="mr-2">mdi-account-switch-outline</v-icon><span>Concedii care așteaptă confirmarea ta ca înlocuitor</span></div>
      <DxDataGrid :data-source="inlocuitor" key-expr="ID" :show-borders="false" :show-column-lines="false" :show-row-lines="true"
        :hover-state-enabled="true" :no-data-text="loading ? 'Se încarcă…' : 'Nicio solicitare de înlocuire.'">
        <DxColumn data-field="NumeAngajat" caption="Solicitant" :min-width="180" cell-template="iAngCell" />
        <DxColumn data-field="TipConcediu" caption="Tip" :width="120" cell-template="iTipCell" />
        <DxColumn data-field="PerioadaText" caption="Perioadă" :width="210" cell-template="iPerCell" :allow-filtering="false" />
        <DxColumn data-field="NumarZile" caption="Zile" :width="70" alignment="center" cell-template="iZileCell" />
        <DxColumn data-field="Descriere" caption="Descriere" :min-width="150" />
        <DxColumn caption="" :width="140" :allow-filtering="false" :allow-sorting="false" cell-template="confActCell" />
        <template #iAngCell="{ data }"><div class="ang"><span class="avatar">{{ data.data.Initiale }}</span><span class="ang-nume">{{ data.data.NumeAngajat || 'Coleg' }}</span></div></template>
        <template #iTipCell="{ data }"><span class="tip-badge">{{ data.data.TipConcediu || 'CO' }}</span></template>
        <template #iPerCell="{ data }"><div class="perioada"><v-icon size="15" color="#ff5722" class="mr-1">mdi-calendar-range</v-icon>{{ data.data.PerioadaText }}</div></template>
        <template #iZileCell="{ data }"><span class="zile-badge">{{ data.data.NumarZile }}</span></template>
        <template #confActCell="{ data }"><v-btn size="small" class="btn-ok" prepend-icon="mdi-check-circle" @click="openConfirm(data.data)">Confirmă</v-btn></template>
        <DxPaging :page-size="12" /><DxSorting mode="single" /><DxFilterRow :visible="true" />
      </DxDataGrid>
    </div>

    <!-- Înlocuiri tichete (read-only) -->
    <div v-show="tab === 'inlt'" class="grid-card">
      <div class="grid-head"><v-icon size="18" color="#ff5722" class="mr-2">mdi-ticket-confirmation-outline</v-icon><span>Tichete în care ești desemnat înlocuitor</span></div>
      <DxDataGrid :data-source="tichete" key-expr="ID" :show-borders="false" :show-column-lines="false" :show-row-lines="true"
        :hover-state-enabled="true" :no-data-text="loading ? 'Se încarcă…' : 'Niciun tichet.'">
        <DxColumn data-field="NumeAngajat" caption="Solicitant" :min-width="180" cell-template="tAngCell" />
        <DxColumn data-field="TipCerere" caption="Tip cerere" :width="150" cell-template="tTipCell" />
        <DxColumn data-field="PerioadaText" caption="Perioadă" :width="210" cell-template="tPerCell" :allow-filtering="false" />
        <DxColumn data-field="ZileText" caption="Zile / Durată" :width="120" alignment="center" cell-template="tZileCell" :allow-filtering="false" />
        <DxColumn data-field="DestinatieText" caption="Destinație" :min-width="140" />
        <DxColumn data-field="Explicatie" caption="Explicație" :min-width="160" />
        <template #tAngCell="{ data }"><div class="ang"><span class="avatar">{{ data.data.Initiale }}</span><span class="ang-nume">{{ data.data.NumeAngajat || 'Coleg' }}</span></div></template>
        <template #tTipCell="{ data }"><span class="tip-badge tip-tichet">{{ data.data.TipCerere || 'Tichet' }}</span></template>
        <template #tPerCell="{ data }"><div class="perioada"><v-icon size="15" color="#ff5722" class="mr-1">mdi-calendar-range</v-icon>{{ data.data.PerioadaText }}</div></template>
        <template #tZileCell="{ data }"><span class="zile-badge">{{ data.data.ZileText }}</span></template>
        <DxPaging :page-size="12" /><DxSorting mode="single" /><DxFilterRow :visible="true" />
      </DxDataGrid>
    </div>

    <!-- Deconturi -->
    <div v-show="tab === 'decont'" class="grid-card">
      <div class="grid-head"><v-icon size="18" color="#ff5722" class="mr-2">mdi-cash-multiple</v-icon><span>Deconturi de aprobat</span></div>
      <DxDataGrid :data-source="deconturi" key-expr="ID" :show-borders="false" :show-column-lines="false" :show-row-lines="true"
        :hover-state-enabled="true" :no-data-text="loading ? 'Se încarcă…' : 'Niciun decont de aprobat.'">
        <DxColumn data-field="NumeAngajat" caption="Solicitant" :min-width="180" cell-template="dAngCell" />
        <DxColumn data-field="Numar" caption="Număr" :width="120" />
        <DxColumn data-field="Data" caption="Data" data-type="date" format="dd.MM.yyyy" :width="120" />
        <DxColumn data-field="Explicatie" caption="Explicație" :min-width="180" />
        <DxColumn data-field="Total" caption="Total" :width="120" alignment="right" cell-template="dTotalCell" />
        <DxColumn caption="" :width="200" :allow-filtering="false" :allow-sorting="false" cell-template="dActCell" />
        <template #dAngCell="{ data }"><div class="ang"><span class="avatar">{{ data.data.Initiale }}</span><span class="ang-nume">{{ data.data.NumeAngajat || 'Angajat' }}</span></div></template>
        <template #dTotalCell="{ data }"><span class="zile-badge">{{ formatSuma(data.data.Total) }}</span></template>
        <template #dActCell="{ data }">
          <v-btn size="small" class="btn-ok mr-1" variant="flat" @click="openActiuneDecont(data.data, true)"><v-icon size="18">mdi-check</v-icon></v-btn>
          <v-btn size="small" class="btn-no" variant="flat" @click="openActiuneDecont(data.data, false)"><v-icon size="18">mdi-close</v-icon></v-btn>
        </template>
        <DxPaging :page-size="12" /><DxSorting mode="single" /><DxFilterRow :visible="true" />
      </DxDataGrid>
    </div>

    <!-- Dialog aprobare/respingere decont -->
    <v-dialog v-model="dlgAprobDecont" max-width="480">
      <v-card rounded="xl" class="dlg-card">
        <div class="dlg-head" :class="{ no: !aprobDecont }">
          <div class="dlg-ic"><v-icon color="#fff" size="20">{{ aprobDecont ? 'mdi-check-decagram' : 'mdi-close-octagon' }}</v-icon></div>
          <div class="dlg-txt"><div class="dlg-title">{{ aprobDecont ? 'Aprobă decontul' : 'Respinge decontul' }}</div><div class="dlg-desc">{{ selDecont?.NumeAngajat }} · {{ selDecont?.Numar }}</div></div>
          <v-btn icon="mdi-close" variant="text" color="#fff" size="small" @click="dlgAprobDecont = false" />
        </div>
        <v-card-text class="pa-5">
          <v-textarea v-model="obsDecont" :label="aprobDecont ? 'Observație (opțional)' : 'Motiv respingere'" variant="outlined" density="comfortable" rows="2" hide-details />
        </v-card-text>
        <v-card-actions class="dlg-foot">
          <v-btn variant="text" @click="dlgAprobDecont = false">Anulează</v-btn><v-spacer />
          <v-btn :class="aprobDecont ? 'btn-ok' : 'btn-no'" class="px-6" :loading="act" @click="confirmActiuneDecont">
            <v-icon start>{{ aprobDecont ? 'mdi-check' : 'mdi-close' }}</v-icon>{{ aprobDecont ? 'Aprobă' : 'Respinge' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog aprobare/respingere -->
    <v-dialog v-model="dlgAprob" max-width="480">
      <v-card rounded="xl" class="dlg-card">
        <div class="dlg-head" :class="{ no: !aprob }">
          <div class="dlg-ic"><v-icon color="#fff" size="20">{{ aprob ? 'mdi-check-decagram' : 'mdi-close-octagon' }}</v-icon></div>
          <div class="dlg-txt"><div class="dlg-title">{{ aprob ? 'Aprobă cererea' : 'Respinge cererea' }}</div><div class="dlg-desc">{{ sel?.NumeAngajat }} · {{ sel?.PerioadaText }}</div></div>
          <v-btn icon="mdi-close" variant="text" color="#fff" size="small" @click="dlgAprob = false" />
        </div>
        <v-card-text class="pa-5">
          <v-textarea v-model="obs" :label="aprob ? 'Observație (opțional)' : 'Motiv respingere'" variant="outlined" density="comfortable" rows="2" hide-details />
        </v-card-text>
        <v-card-actions class="dlg-foot">
          <v-btn variant="text" @click="dlgAprob = false">Anulează</v-btn><v-spacer />
          <v-btn :class="aprob ? 'btn-ok' : 'btn-no'" class="px-6" :loading="act" @click="confirmActiune">
            <v-icon start>{{ aprob ? 'mdi-check' : 'mdi-close' }}</v-icon>{{ aprob ? 'Aprobă' : 'Respinge' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog confirmare înlocuitor -->
    <v-dialog v-model="dlgConf" max-width="460">
      <v-card rounded="xl" class="dlg-card">
        <div class="dlg-head">
          <div class="dlg-ic"><v-icon color="#fff" size="20">mdi-account-check-outline</v-icon></div>
          <div class="dlg-txt"><div class="dlg-title">Confirmă înlocuirea</div><div class="dlg-desc">{{ sel?.NumeAngajat }} · {{ sel?.PerioadaText }}</div></div>
          <v-btn icon="mdi-close" variant="text" color="#fff" size="small" @click="dlgConf = false" />
        </div>
        <v-card-text class="pa-5">
          <v-textarea v-model="obs" label="Observație / explicație (opțional)" variant="outlined" density="comfortable" rows="2" hide-details />
        </v-card-text>
        <v-card-actions class="dlg-foot">
          <v-btn variant="text" @click="dlgConf = false">Anulează</v-btn><v-spacer />
          <v-btn class="btn-ok px-6" :loading="act" @click="confirmInlocuire"><v-icon start>mdi-check-circle</v-icon>Confirmă</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { DxDataGrid, DxColumn, DxPaging, DxFilterRow, DxSorting } from 'devextreme-vue/data-grid'
import notify from 'devextreme/ui/notify'
import PORTAL_Aprobari from '@/services/Portal/PORTAL_Aprobari'
import PORTAL_Decont from '@/services/Portal/PORTAL_Decont'

export default defineComponent({
  name: 'AprobariManager',
  components: { DxDataGrid, DxColumn, DxPaging, DxFilterRow, DxSorting },
  data() {
    return {
      loading: false, act: false,
      tab: 'aprob',
      concedii: [] as any[], inlocuitor: [] as any[], tichete: [] as any[], deconturi: [] as any[],
      dlgAprob: false, dlgConf: false, aprob: true, sel: null as any, obs: '',
      dlgAprobDecont: false, aprobDecont: true, selDecont: null as any, obsDecont: '',
    }
  },
  computed: {
    total(): number { return this.concedii.length + this.inlocuitor.length + this.deconturi.length; }
  },
  mounted() { this.incarca(); },
  methods: {
    fmt(d: any) { return d ? new Date(d).toLocaleDateString('ro-RO', { day: '2-digit', month: '2-digit', year: 'numeric' }) : '—'; },
    ini(n?: string) { return n ? n.split(/\s+/).filter(Boolean).slice(0, 2).map(w => w[0]).join('').toUpperCase() : '?'; },
    mapCerere(c: any) { return { ...c, Initiale: this.ini(c.NumeAngajat), PerioadaText: `${this.fmt(c.DataInceput)} → ${this.fmt(c.DataSfarsit)}` }; },
    async incarca() {
      this.loading = true;
      try {
        const [pend, inl, tic, dec] = await Promise.all([
          PORTAL_Aprobari.getPending().catch(() => null),
          PORTAL_Aprobari.getInlocuitorPending().catch(() => null),
          PORTAL_Aprobari.getInlocuitorPendingTichete().catch(() => null),
          PORTAL_Decont.getDeAprobat().catch(() => null),
        ]);
        this.concedii = (pend?.data?.Concedii ?? []).map((c: any) => this.mapCerere(c));
        this.inlocuitor = (inl?.data?.Cereri ?? []).map((c: any) => this.mapCerere(c));
        this.tichete = (tic?.data?.Tichete ?? []).map((t: any) => ({
          ...t, Initiale: this.ini(t.NumeAngajat),
          PerioadaText: t.DataStop ? `${t.DataStart} → ${t.DataStop}` : (t.DataStart || '—'),
          ZileText: t.DurataZile || t.NumarZile || t.Durata || t.NumarOre || '—',
          DestinatieText: t.Destinatie || t.Locatie || '—',
        }));
        this.deconturi = (dec?.data ?? []).map((d: any) => ({ ...d, Initiale: this.ini(d.NumeAngajat) }));
      } finally { this.loading = false; }
    },
    formatSuma(v: number) { return (Number(v) || 0).toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); },
    openActiuneDecont(d: any, aprob: boolean) { this.selDecont = d; this.aprobDecont = aprob; this.obsDecont = ''; this.dlgAprobDecont = true; },
    async confirmActiuneDecont() {
      if (!this.selDecont) return;
      this.act = true;
      try {
        if (this.aprobDecont) await PORTAL_Decont.aproba(this.selDecont.ID, this.obsDecont);
        else await PORTAL_Decont.respinge(this.selDecont.ID, this.obsDecont);
        notify(this.aprobDecont ? 'Decont aprobat.' : 'Decont respins.', 'success', 3000);
        this.dlgAprobDecont = false;
        await this.incarca();
      } catch { notify('Eroare. Încearcă din nou.', 'error', 3500); }
      finally { this.act = false; }
    },
    openActiune(c: any, aprob: boolean) { this.sel = c; this.aprob = aprob; this.obs = ''; this.dlgAprob = true; },
    async confirmActiune() {
      if (!this.sel) return;
      this.act = true;
      try {
        if (this.aprob) await PORTAL_Aprobari.aprobare(this.sel.ID, 'concediu', this.obs);
        else await PORTAL_Aprobari.respingere(this.sel.ID, 'concediu', this.obs);
        notify(this.aprob ? 'Cerere aprobată.' : 'Cerere respinsă.', 'success', 3000);
        this.dlgAprob = false;
        await this.incarca();
      } catch { notify('Eroare. Încearcă din nou.', 'error', 3500); }
      finally { this.act = false; }
    },
    openConfirm(c: any) { this.sel = c; this.obs = ''; this.dlgConf = true; },
    async confirmInlocuire() {
      if (!this.sel) return;
      this.act = true;
      try {
        await PORTAL_Aprobari.confirmaInlocuitor(this.sel.ID, this.obs);
        notify('Ai confirmat înlocuirea. Cererea a mers la superior.', 'success', 3500);
        this.dlgConf = false;
        await this.incarca();
      } catch { notify('Eroare la confirmare.', 'error', 3500); }
      finally { this.act = false; }
    },
  }
})
</script>

<style scoped>
.apr-page { padding: 16px; width: 100%; }
.hero { display: flex; align-items: center; justify-content: space-between; gap: 16px; flex-wrap: wrap;
  background: linear-gradient(120deg, #ff5722 0%, #ff7a45 55%, #ff9a5c 100%); border-radius: 18px; padding: 22px 26px; color: #fff;
  box-shadow: 0 10px 30px rgba(255, 87, 34, .28); margin-bottom: 14px; }
.hero-eyebrow { font-size: 10px; font-weight: 700; letter-spacing: 2px; opacity: .85; }
.hero-title { font-size: 23px; font-weight: 800; line-height: 1.2; margin: 4px 0 2px; }
.hero-sub { font-size: 13px; opacity: .92; margin: 0; max-width: 640px; }
.co-chip { display: flex; align-items: center; gap: 5px; background: rgba(255, 255, 255, .22); padding: 9px 15px; border-radius: 22px; }
.co-val { font-size: 18px; font-weight: 800; }
.co-lbl { font-size: 11px; font-weight: 600; opacity: .92; }
.apr-tabs { margin-bottom: 12px; }

.grid-card { background: #fff; border: 1px solid #eef1f6; border-radius: 16px; box-shadow: 0 1px 3px rgba(15,23,42,.05); overflow: hidden; }
.grid-head { display: flex; align-items: center; padding: 15px 20px; border-bottom: 1px solid #f1f5f9; font-size: 14px; font-weight: 700; color: #1e293b; }
.ang { display: flex; align-items: center; gap: 10px; }
.avatar { width: 32px; height: 32px; border-radius: 9px; flex: 0 0 32px; background: #fff1ec; color: #ff5722; display: flex; align-items: center; justify-content: center; font-weight: 800; font-size: 12px; }
.ang-nume { font-weight: 700; color: #1e293b; }
.tip-badge { display: inline-block; padding: 3px 10px; border-radius: 8px; background: #eff6ff; color: #2563eb; font-weight: 700; font-size: 12px; }
.tip-tichet { background: #f5f3ff; color: #8b5cf6; }
.perioada { display: flex; align-items: center; font-weight: 600; color: #1e293b; }
.zile-badge { display: inline-block; min-width: 28px; padding: 3px 8px; border-radius: 8px; background: #fff1ec; color: #ff5722; font-weight: 800; font-size: 13px; text-align: center; }
.btn-ok { background: #16a34a !important; color: #fff !important; font-weight: 700; border-radius: 9px; text-transform: none; min-width: 0; }
.btn-no { background: #dc2626 !important; color: #fff !important; font-weight: 700; border-radius: 9px; text-transform: none; min-width: 0; }

.dlg-card { overflow: hidden; }
.dlg-head { display: flex; align-items: center; gap: 12px; background: linear-gradient(120deg,#16a34a,#4ade80); color: #fff; padding: 16px 18px; }
.dlg-head.no { background: linear-gradient(120deg,#dc2626,#f87171); }
.dlg-ic { width: 40px; height: 40px; border-radius: 12px; background: rgba(255,255,255,.2); display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.dlg-title { font-size: 16px; font-weight: 800; line-height: 1.15; }
.dlg-desc { font-size: 12px; opacity: .92; margin-top: 2px; }
.dlg-foot { padding: 14px 20px; border-top: 1px solid #eef1f6; }
</style>
